import { useQuery } from '@tanstack/react-query';
import { emailDomainsApi } from '../services';

/**
 * Hook para buscar um dominio de email por ID.
 *
 * @param id - ID do dominio
 * @returns Query com dados do dominio
 *
 * @example
 * ```tsx
 * const { data: domain, isLoading } = useEmailDomain(domainId);
 * ```
 */
export const useEmailDomain = (id: string) => {
  return useQuery({
    queryKey: ['email-domains', id],
    queryFn: () => emailDomainsApi.getById(id),
    staleTime: 30_000,
    enabled: !!id,
  });
};
